import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { ThreadObject } from '@/types';

export const useGetThreadStatus = ({
  matterId,
  subsetId,
  threadId,
}: {
  matterId: string;
  subsetId: string;
  threadId: string;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getThreadStatus = async (): Promise<ThreadObject> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread/${threadId}`,
      fetchConfigGET,
    );
    if (!response.ok) {
      throw new Error('Fetching messages failed');
    }
    return response.json();
  };

  return useQuery([QueryEntity.ThreadStatus, { threadId }], getThreadStatus, {
    cacheTime: 0,
  });
};
